import {PagingCtrl} from "../PagingCtrl";
import {Asset} from "../../entities/Asset";
import { StateService, StateParams } from "@uirouter/angularjs";
import {CmdCenterAssetCmdModel} from "../../models/cmd/CmdCenterAssetCmdModel";
import {NotificationService} from "../../services/NotificationService";
import { ApplicationSettingService } from "../../services/ApplicationSettingService";

export class CmdCenterAssetCmdCtrl extends PagingCtrl<Asset>{
    public static $inject = ['$scope', '$location', '$state', '$stateParams', 'CmdCenterAssetCmdModel','ApplicationSettingService'];
    localGridOptions: any;
    temperatureFormat: string;
    constructor($scope:any, $location: ng.ILocationService, stateService:StateService,
                stateParamsService:StateParams,
        public model: CmdCenterAssetCmdModel,
        public applicationSettingService: ApplicationSettingService,
                public notificationService:NotificationService) {
        super($scope, $location, stateService, stateParamsService, model, notificationService);
        $scope.vm = this;
        this.localGridOptions = {
            enablePaging:false,
            columnDefs:[],
            data:model.addedAssets,
            onRegisterApi:function(gridApi:any) {
                gridApi.selection.on.rowSelectionChanged($scope,function(row:any){
                    var entity = row.entity;
                    //alert("row selection changed. entity.name="+entity.name+". is selected="+row.isSelected);
                    if(row.isSelected)
                        $scope.vm.model.addAddedSelected(entity);
                    else
                        $scope.vm.pagingModel.removeAddedSelected(entity);
                });
                gridApi.selection.on.rowSelectionChangedBatch($scope,function(rows:any){
                    $.each(rows, (i, row) => {
                        var entity = row.entity;
                        if(row.isSelected)
                            $scope.vm.pagingModel.addAddedSelected(entity);
                        else
                            $scope.vm.pagingModel.removeAddedSelected(entity);
                    });
                });
            }
        };
        this.applicationSettingService.getCached().then((data) => {
            this.temperatureFormat = data.temperatureFormat;
        });
        this.pagingModel.getColumnDefs().then(()=>{
            this.localGridOptions.columnDefs = this.setColumns();
        });
    }
    add(){
        if(this.model.selectedItems.length > 0){
            $.each(this.model.selectedItems, (index,val)=>{
                var found = false;
                for(var i=0;i<this.model.addedAssets.length;i++){
                    if(this.model.addedAssets[i].id == val.id){
                        found = true;
                        break;
                    }
                }
                if(!found){
                    this.model.addedAssets.push(val);
                }
            });
        }
    }
    remove(){
        var toRemove = this.model.selectedAddedAssets.slice(0);
        $.each(toRemove,(index,val)=>{
            this.model.selectedAddedAssets.splice(this.model.selectedAddedAssets.indexOf(val),1);
            this.model.addedAssets.splice(this.model.addedAssets.indexOf(val),1);
        });
    }
    runCommand(){

    }
}
